import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IPurchaseAccountInformationService } from "services/PurchaseAccountInformationService";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  PurchaseAccountSelectModels: new Array<GuidSelectModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const purchaseAccountSelectSlice = createSlice({
  name: "purchaseAccountSelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseAccountSelectModels.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getPurchaseAccountSelectModels.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getPurchaseAccountSelectModels.fulfilled, (state, action) => {
        state.PurchaseAccountSelectModels = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getPurchaseAccountSelectModels = createAsyncThunk("PurchaseAccounts/GetSelectModels", async () => {
  const purchaseAccountsService = container.get<IPurchaseAccountInformationService>(
    SERVICE_TYPES.PurchaseAccountInformationService
  );
  return await purchaseAccountsService.getSelectModels();
});

export const selectPurchaseAccountSelectModels = (state: RootState) => {
  return state.purchaseAccountSelect.PurchaseAccountSelectModels;
};
export const selectLoading = (state: RootState) => {
  return state.purchaseAccountSelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.purchaseAccountSelect.LastUpdateTime;
};

export default purchaseAccountSelectSlice.reducer;
